import { render, staticRenderFns } from "./OnlineEvents.vue?vue&type=template&id=8c064812&scoped=true&"
import script from "./OnlineEvents.vue?vue&type=script&lang=js&"
export * from "./OnlineEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c064812",
  null
  
)

export default component.exports